const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

const PENDING_STATUSES = new Set(['PENDING', 'PENDING_LIVE_CONFIRM']);
const CONFIRMED_STATUSES = new Set(['CONFIRMED', 'ACCEPTED', 'PENDING_CANCEL_LOCK']);
const REJECTED_STATUSES = new Set(['REJECTED', 'CANCELLED', 'CANCELED']);

const rejectionMessage = (reason) => {
  const code = String(reason || '').toUpperCase();
  if (code === 'ODDS_CHANGED') return '배당이 변경되어 인플레이 베팅이 확정되지 않았습니다.';
  if (code === 'SELECTION_UNAVAILABLE') return '선택지가 닫혀 인플레이 베팅이 확정되지 않았습니다.';
  if (code === 'MARKET_UNAVAILABLE') return '마켓이 닫혀 인플레이 베팅이 확정되지 않았습니다.';
  if (code === 'FIXTURE_NOT_LIVE') return '경기 상태가 변경되어 인플레이 베팅이 확정되지 않았습니다.';
  return '배당 변동 또는 마켓 상태 변경으로 인플레이 베팅이 거부되었습니다';
};

const normalizeBet = (bet) => {
  if (!bet) return null;
  const rawStatus = String(bet.status || '').toUpperCase();
  if (PENDING_STATUSES.has(rawStatus)) return { ...bet, originalStatus: rawStatus, status: 'PENDING' };
  if (CONFIRMED_STATUSES.has(rawStatus)) return { ...bet, originalStatus: rawStatus, status: 'CONFIRMED' };
  if (REJECTED_STATUSES.has(rawStatus)) {
    const reason = bet.rejectionReason || bet.rejection_reason || bet.void_reason;
    return { ...bet, originalStatus: rawStatus, status: 'REJECTED', void_reason: rejectionMessage(reason) };
  }
  return { ...bet, originalStatus: rawStatus, status: rawStatus || bet.status };
};

const fetchBetDetail = async (SportsService, betId) => {
  if (typeof SportsService?.getBet === 'function') return SportsService.getBet(betId);
  if (typeof SportsService?.getMyBetDetail === 'function') return SportsService.getMyBetDetail(betId);
  throw new Error('BET_DETAIL_SERVICE_UNAVAILABLE');
};

export const waitForPendingBetResolution = async ({
  SportsService,
  betId,
  delaySeconds = 0,
  onTick,
  isCancelled,
  pollIntervalMs = 700,
  pollTimeoutMs = 12000,
}) => {
  if (isCancelled?.()) return null;
  const totalSeconds = Math.max(Math.ceil(Number(delaySeconds) || 0), 0);
  onTick?.(totalSeconds);

  for (let remaining = totalSeconds; remaining > 0; remaining -= 1) {
    if (isCancelled?.()) return null;
    await sleep(1000);
    if (isCancelled?.()) return null;
    onTick?.(remaining - 1);
  }

  const startedAt = Date.now();
  while (Date.now() - startedAt <= pollTimeoutMs) {
    if (isCancelled?.()) return null;
    const response = await fetchBetDetail(SportsService, betId);
    if (response?.status) {
      const bet = normalizeBet(response?.data?.data || response?.data || response?.bet || null);
      if (bet?.status && bet.status !== 'PENDING') {
        return bet;
      }
    }
    if (isCancelled?.()) return null;
    await sleep(pollIntervalMs);
  }

  return null;
};
